export const ROI_LIMITS = {
  applicants: { min: 10, max: 2000, step: 10, fallback: 120 },
  minutes: { min: 5, max: 90, step: 5, fallback: 15 },
  roles: { min: 1, max: 30, step: 1, fallback: 2 },
};

const clamp = (value, { min, max, step, fallback }) => {
  if (value == null || value === "") return fallback;
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  const bounded = Math.min(max, Math.max(min, Math.round(n)));
  const steps = Math.round((bounded - min) / step);
  return Math.min(max, min + steps * step);
};

export const clampRoi = (applicants, minutes, roles) => ({
  applicants: clamp(applicants, ROI_LIMITS.applicants),
  minutes: clamp(minutes, ROI_LIMITS.minutes),
  roles: clamp(roles, ROI_LIMITS.roles),
});

export const readRoiFromSearch = (search) => {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const hasAny = ["applicants", "minutes", "roles"].some((key) => params.has(key));
  return { ...clampRoi(params.get("applicants"), params.get("minutes"), params.get("roles")), hasAny };
};

export const readUtm = (search) => {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const utm = {};
  ["source", "medium", "campaign", "content", "term"].forEach((key) => {
    const value = params.get(`utm_${key}`);
    if (value) utm[key] = value.slice(0, 200);
  });
  return utm;
};

export const shareSearch = ({ applicants, minutes, roles }, currentSearch = "") => {
  const params = new URLSearchParams(currentSearch.startsWith("?") ? currentSearch.slice(1) : currentSearch);
  params.set("applicants", String(applicants));
  params.set("minutes", String(minutes));
  params.set("roles", String(roles));
  return params.toString();
};

export const roiResult = ({ applicants, minutes, roles }) => {
  const hoursPerApplicant = minutes / 60;
  const hoursPerRole = applicants * hoursPerApplicant;
  const hoursPerMonth = hoursPerRole * roles;
  const hoursPerYear = hoursPerMonth * 12;
  return { hoursPerApplicant, hoursPerRole, hoursPerMonth, hoursPerYear };
};

export const formatHours = (hours) => {
  const decimals = hours > 0 && hours < 10 ? 2 : 1;
  const factor = 10 ** decimals;
  const rounded = Math.round(hours * factor) / factor;
  const fixed = rounded.toFixed(decimals);
  const [whole, frac = ""] = fixed.split(".");
  const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const trimmed = frac.replace(/0+$/, "");
  const text = trimmed ? `${withCommas}.${trimmed}` : withCommas;
  const unit = rounded === 1 ? "hour" : "hours";
  return { text, unit, label: `${text} ${unit}` };
};
